function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 2");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Mobile",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home",
  transform: "translate(-61.000000, -235.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(60.000000, 234.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  fill: "#7B9EB0"
}, /*#__PURE__*/React.createElement("g", {
  id: "map-(1)",
  transform: "translate(1.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.9041388,4.11908833 C18.4429905,-1.37302944 9.55707555,-1.37302944 4.09586122,4.11908833 C-1.36528707,9.6112061 -1.36528707,18.5475783 4.09586122,24.0396961 L14,34 L23.9041388,24.0396961 C29.3652871,18.5475783 29.3652871,9.6112061 23.9041388,4.11908833 Z M5.93715704,14.0825802 C5.93715704,9.61153817 9.55416974,5.97401386 14,5.97401386 C18.4458303,5.97401386 22.062843,9.61153817 22.062843,14.0825802 C22.062843,18.5536886 18.4458303,22.1911465 14,22.1911465 C9.55416974,22.1911465 5.93715704,18.5536222 5.93715704,14.0825802 Z",
  id: "Shape"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  transform: "translate(15.000000, 15.000000) rotate(-67.485887) translate(-15.000000, -15.000000) ",
  cx: 15,
  cy: 15,
  r: 11
})), /*#__PURE__*/React.createElement("g", {
  id: "front-store",
  transform: "translate(8.000000, 9.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.2222222,0 L0.777777778,0 L0.777777778,1.5 L13.2222222,1.5 L13.2222222,0 Z M14,7.5 L14,6 L13.2222222,2.25 L0.777777778,2.25 L0,6 L0,7.5 L0.777777778,7.5 L0.777777778,12 L8.55555556,12 L8.55555556,7.5 L11.6666667,7.5 L11.6666667,12 L13.2222222,12 L13.2222222,7.5 L14,7.5 Z M7,10.5 L2.33333333,10.5 L2.33333333,7.5 L7,7.5 L7,10.5 Z",
  id: "Shape"
})))));

var SvgPdvInitial = function SvgPdvInitial(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "34px",
    viewBox: "0 0 28 34",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdvInitial, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdv-initial.42038722.svg";
export { ForwardRef as ReactComponent };